import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormioCustomComponent } from 'angular-formio';
import { AppService } from '../app.service';

@Component({
  selector: 'app-fileUpload-wrapper',
  templateUrl: './fileUpload-formio.component.html',
  // styleUrls: ['./rating-wrapper.component.scss']
})
export class FileUploadFormioComponent implements FormioCustomComponent<number> {
  baseUrl: string;
  afuConfig: any;
  appService: AppService;

  @Input()
  value: number;

  @Input() placeholder: string;

  @Output()
  valueChange = new EventEmitter<number>();

  @Input()
  disabled: boolean;
  constructor(appService: AppService, @Inject('BASE_URL') baseUrl: string){
    this.baseUrl = baseUrl + 'api/SampleData/PostDocumentsAsync';
    //this.baseUrl = 'http://localhost:44381/api/SampleData/PostDocumentsAsync';
    this.afuConfig = {
      uploadAPI: {
        url: this.baseUrl
        // headers: {
        //   "documentFor": this.documentFor
        // }
        //url: 'https://slack.com/api/files.upload'
      },
      formatsAllowed: '.jpg,.png,.pdf,.docx,.txt,.gif,.jpeg,.zip,.xls,.xlsx',
      maxSize: 1000,
      // replaceTexts: {
      //   selectFileBtn: 'Select Files',
      //   resetBtn: 'Reset',
      //   uploadBtn: 'Upload',
      //   dragNDropBox: 'Drag N Drop',
      //   attachPinBtn: 'Attach Files...',
      //   afterUploadMsg_success: 'Successfully Uploaded !',
      //   afterUploadMsg_error: 'Upload Failed !',
      //   sizeLimit: 'Size Limit'
      // },
      theme: "default",
      multiple: "true"
    };
    this.appService = appService;
  }
  DocUpload($event: any) {
    console.log("response from upload", $event.body);
    // this.valueChange.emit(1);
    this.appService.setUrl(this.placeholder, $event.body);
  }
}
